<template>

  <a target="_blank" :href="item.pdf">
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false">
      <template slot="loading">

      </template>
    </pdf>
  </a>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'Arbitrage',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "http://www.asspm.fr/lab/data/apps/asspm/images/Planning_Accompagnement_Arbitres_2018_2019_V3.pdf"
        }
      }
    }
  }

</script>